import { render, staticRenderFns } from "./preRegistrationEnd.vue?vue&type=template&id=c60d265e&"
import script from "./preRegistrationEnd.vue?vue&type=script&lang=js&"
export * from "./preRegistrationEnd.vue?vue&type=script&lang=js&"
import style0 from "./preRegistrationEnd.vue?vue&type=style&index=0&id=c60d265e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports